// extracted by mini-css-extract-plugin
module.exports = {"collection":"ConsentsCollection_collection__2BAKu","item":"ConsentsCollection_item__1pGR3","header":"ConsentsCollection_header__13Wxg"};